<template>
    <div class="submit"><input class="form-submit btn btn-primary" type="submit" :value="to.label || 'Submit'" /></div>
</template>

<script>
    import baseField from 'vue-formly-bootstrap/src/fields/baseField'

    export default {
        mixins: [baseField],
        props: ['form', 'field', 'model'],
        name: 'submitButton',
        data () {
            return {}
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// SubmitButton.vue?21985daf